
export default {
  name: 'BodyFatCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What is a good body fat percentage?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Determining the ideal body fat percentage is based on your age and gender. For example, women aged 20-39 should keep their fat percentage between 21-32% while men are 8% to 19%."
        }
      },{
        "@type": "Question",
        "name": "How do I lower my body fat percentage from 25 to 15?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To effectively reduce body fat from 25% to 15%, you should consider the following methods: Exercise regularly. Limit the absorption of bad fats. Combination of aerobic exercises. Drink enough water every day."
        }
      },{
        "@type": "Question",
        "name": "How do I know what my ideal essential body fat is?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The amount of fat needed by women and men is very different. Men need between 2-24% fat for the body to be healthy and develop at its best. In contrast, women need at least 10% fat to ensure enough energy to supply the body."
        }
      },{
        "@type": "Question",
        "name": "Can you see abs at 18 body fat?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The short answer is yes. You can see abs with regular exercise if your body composition is between 14-20% for women and 6-13% for men."
        }
      },{
        "@type": "Question",
        "name": "How can I lose body fat without losing muscle mass?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "There are many ways to burn fat without losing muscle mass. Some valuable solutions include: Provide enough protein. Supplement vitamins from fruits and vegetables. Burn 2-3 servings of carbohydrates daily. Combine cardio and lose weight training regularly. Full rest."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        unit: 'metric',
        gender: 'male',
        height_metric: 175,
        weight_metric: 70,
        neck_metric: 50,
        waist_metric: 96,
        hip_metric: 92,
        weight_us: 160,
        height_us_feet: 5,
        height_us_inch: 10,
        neck_us_feet: 1,
        neck_us_inch: 7.5,
        waist_us_feet: 3,
        waist_us_inch: 1.5,
        hip_us_feet: 2,
        hip_us_inch: 10.5
      })
    }
  },
  methods: {
    onBodyFatCalculator() {
        this.form.post(`/tool/body-fat-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
